import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import ReportsPage from "../Reports/ReportsPage";
import AdminFunctionPage from "./adminFunctions/AdminFunctionPage";
import AdminDashboardPage from "../presclub/dashboard/AdminDashboardPage";

const AdminPages = (props) => {
  return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu isAdmin={props.profile.isAdmin} />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
          <Switch>
            <Route path="/administration/reports" component={ReportsPage} />
            <Route path="/administration/admin" component={AdminFunctionPage} />
            <Route path="/administration/presclubadmin" component={AdminDashboardPage} />
          </Switch>
        </Row>
      </Col>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return { profile: state.profile };
};

export default connect(mapStateToProps)(AdminPages);
